import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_AIRLINES'),
  ...asyncTypes('CREATE_AIRLINES')
};

export default TYPES;
